import { useAtom } from "jotai";
import React from "react";
import { StyledButton } from "../components/Button";
import Icon from "../components/Icon";
import { sideNavOnAtom } from "../jotai/atoms";
import { styled } from "../stitches.config";
import AVControls from "./AVControls";
import Overflow from "./NavigationOverflow";
import Share from "./Share";
import SkipNav from "./SkipNav";
import SpaceName from "./SpaceName";
import BuddyList from "./user/BuddyList";

function Navigation() {
  const [navOn, setNavOn] = useAtom(sideNavOnAtom);

  function onSideNavClick() {
    setNavOn(!navOn);
  }

  return (
    <Bar className="navigation-bar" shifted={navOn}>
      <Title>
        <SkipNav />
        <SpaceName />
      </Title>
      <div
        style={{
          justifySelf: "start",
          display: "flex",
          placeItems: "center",
          order: -1, // Title should be first in DOM, so we move left contents via css
        }}
      >
        <SideNavButton
          onClick={onSideNavClick}
          title="Toggle side navigation (command + i)"
        >
          <Icon icon="Sidebar" fill="none" />
        </SideNavButton>
        <Overflow />
      </div>
      <div
        style={{ justifySelf: "end", display: "flex", placeItems: "center" }}
      >
        <AVControls />
        <BuddyList />
        <Share />
      </div>
    </Bar>
  );
}

export default React.memo(Navigation);

const Title = styled("div", {
  placeSelf: "center",
  fontWeight: 500,
});

const Bar = styled("nav", {
  position: "fixed",
  top: "$2",
  left: "0",
  maxWidth: "calc(100vw - 1rem)",
  display: "flex",
  paddingLeft: "$1",
  paddingRight: "$1",
  height: "$navBarHeight",
  alignContent: "center",
  cursor: "default",
  zIndex: "$sideNav",
  borderRadius: "$2",
  marginLeft: 20,
  background: "$menuBeige",
  boxShadow: "$cursor",
  transition: "transform 100ms ease-in-out",
  variants: {
    shifted: {
      true: {
        transform: "translateX(calc($sizes$sideNavWidth))",
      },
      false: {
        transform: "translateX(0)",
      },
    },
  },
  [`& ${Title}`]: {
    marginRight: 10,
  },
});

const SideNavButton = styled(StyledButton, {
  boxSizing: "content-box",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  width: 24,
  height: 24,
  padding: "6px 8px",
  margin: 4,
});
